var map = {
	"./apex/colors.scss": [
		31635,
		1635
	],
	"./brove/colors.scss": [
		46250,
		6250
	],
	"./capitalcare/colors.scss": [
		69671,
		9671
	],
	"./malakut/colors.scss": [
		70256,
		256
	],
	"./papseguros/colors.scss": [
		84507,
		4507
	],
	"./portento/colors.scss": [
		64983,
		4983
	],
	"./renova/colors.scss": [
		32959,
		2959
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2533;
module.exports = webpackAsyncContext;